import {
    Grid,
    Typography,
    Paper,
    Tooltip } from "../../ui";
import SnpButton from "../../global/SnpButton";
import {
  InternalBillType,
  isEmpty
} from "../../../constants/constant";
import RefreshIcon from '../../ui/icons/Refresh';
import { getBillTypeName } from "../keyboardbill/quickBillController";

const RenderBillHeader = ({ billNo, 
    selectedDate, 
    handleClearEveryThing, 
    mbackgroundcolor = "transparent",
    billUtils = {billType : -1},token,
    refreshBill = ()=> {},isPaid=false,
    backDateAllowed=false,setDateChange,
}) => {
    const handleDateChange = () => {
        if (backDateAllowed) {
            setDateChange(true);
        }
    }
    return (
        <Paper elevation={0}
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                padding: 1,
                backgroundColor: mbackgroundcolor,
                mt: 1,
                width: "100%",
                boxShadow: 1,
                borderRadius: 5,
            }} >
            <Grid item xs={12}>

                <div style={{
                    display: "flex", justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                }}>
                    {/* Bill No */}
                    <Typography style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                        {
                            !isEmpty(billNo) &&
                            <Tooltip title="Refresh Bill">
                                <RefreshIcon onClick={refreshBill} style={{ cursor: 'pointer' }} />
                            </Tooltip>
                        }
                        <span style={{ color: "rgba(3, 92, 49, 0.88)", fontSize: "14px" }}>Bill No</span>
                        <span style={{ margin: "0 4px" }}>:</span>
                        <span style={{
                            color: "rgba(4, 63, 34, 0.88)", fontFamily: "monospace", whiteSpace: 'pre-wrap',
                            overflowWrap: 'break-word', fontSize: "16px", fontWeight: "bold"
                        }}>{billNo}</span>
                    </Typography>

                    {/* Date */}
                    <Typography sx={{ fontSize: "14px", color: "black" }} onClick={handleDateChange}>
                        Date: {selectedDate}
                    </Typography>

                    <Typography sx={{ fontFamily: "monospace" , fontSize: "14px", color: "blue",fontWeight:"bold",whiteSpace: 'pre-wrap',
                            overflowWrap: 'break-word' }}>
                        {getBillTypeName(billUtils.billType, token, billUtils.tableNo, billUtils.tableName)}
                    </Typography>

                    {/* Create New Bill Button */}
                    {!isPaid && InternalBillType.BookTable !== billUtils.billType  && <SnpButton
                        variant="contained"
                        mbgcolor="#266e8f"
                        disabled={isEmpty(billNo)}
                        onClick={handleClearEveryThing}
                    >
                        Create New Bill
                    </SnpButton>}
                </div>
            </Grid></Paper>
    );
};

export default RenderBillHeader;
